module.exports = __webpack_public_path__ + "media/images/logo/yto-a37ed41aaf576d35cae3cc95cec16bf3.gif";